/**
 * @generated SignedSource<<07ad27904c4b5e3639521050329c2525>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppDialogExposeHourEnum = "day" | "hour" | "month" | "%future added value";
export type AppDialogExposeTypeEnum = "always" | "hour_repeat" | "manual_tag" | "once" | "weekday_repeat" | "%future added value";
export type AppDialogExposeWeekdayEnum = "fri" | "mon" | "sat" | "sun" | "thu" | "tue" | "wed" | "%future added value";
export type AppDialogTypeEnum = "image" | "image_and_text" | "text" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppDialogDescriptionList_appDialog$data = {
  readonly appDeepLink: string | null;
  readonly appDialogImage: {
    readonly objectUrl: string;
  } | null;
  readonly appDialogMobileImage: {
    readonly objectUrl: string;
  } | null;
  readonly appDialogTabletImage: {
    readonly objectUrl: string;
  } | null;
  readonly appDialogType: AppDialogTypeEnum;
  readonly endAt: any;
  readonly exposeHour: AppDialogExposeHourEnum | null;
  readonly exposeTag: string | null;
  readonly exposeType: AppDialogExposeTypeEnum;
  readonly exposeWeekdays: ReadonlyArray<AppDialogExposeWeekdayEnum> | null;
  readonly order: number;
  readonly startAt: any;
  readonly " $fragmentType": "AppDialogDescriptionList_appDialog";
};
export type AppDialogDescriptionList_appDialog$key = {
  readonly " $data"?: AppDialogDescriptionList_appDialog$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppDialogDescriptionList_appDialog">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppDialogDescriptionList_appDialog",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exposeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exposeTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exposeHour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exposeWeekdays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDeepLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "appDialogMobileImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "appDialogTabletImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "appDialogImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    }
  ],
  "type": "AppDialog",
  "abstractKey": null
};
})();

(node as any).hash = "6104cbc56ec2ab1d9f4cb67c2f9cf8e6";

export default node;
